export * from './start-menu/start-menu-art.component';
